import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {ErrorModule} from "../errors/error.module";
import {FileUploadModule} from "ng2-file-upload";
import {UploaderLinkDirective} from "./uploader-link.directive";
import {UploaderDialogComponent} from "./uploader-dialog.component";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ErrorModule,
    FileUploadModule,
  ],
  declarations: [
    UploaderLinkDirective,
    UploaderDialogComponent,
  ],
  entryComponents: [
    UploaderDialogComponent,
  ],
  exports: [
    UploaderLinkDirective,
  ],
})
export class UploaderWrapperModule {
}
